module.exports = __webpack_public_path__ + "img/share_bg_01.346ba24b.png";